// src/pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <main className="notfoundcontainer">
      <span className="material-icons notfound-icon" aria-hidden="true">pets</span>
      <h1>404</h1>
      <p>ขออภัย ไม่พบหน้าที่คุณกำลังค้นหา</p>
      <Link to="/" className="back-button">
        <span className="material-icons" aria-hidden="true">home</span>
        กลับไปหน้าหลัก
      </Link>
    </main>
  );
};

export default NotFound;
